import { useNavigate } from "react-router-dom";
import { isAxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCard } from "@Services/UserService";
import { React_Query_Keys } from "@utils/constants";
import ShowToast from "@utils/showToast";
import { ROUTE_PATHS } from "@routes/constants";

const useGlCodeGroupEdit = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: updateCard,
    mutationKey: [React_Query_Keys.UPDATE_HOME_DEPOT_CARD],
    onError: (error: unknown) => {
      if (isAxiosError(error)) {
        ShowToast(error.response?.data.message, "error");
      }
    },
    onSuccess: () => {
      ShowToast("Card Updated", "success");
      queryClient.invalidateQueries({ queryKey: [React_Query_Keys.FETCH_ALL_HOME_DEPOT_CARDS] });
      navigate(`${ROUTE_PATHS.ADMIN}/settings`);
    }
  });
};

export default useGlCodeGroupEdit;
